"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var S = _interopRequireWildcard(require("./styles"));

var _excluded = ["tag", "pill", "appearance", "children", "color", "fluid", "leftIcon", "rightIcon", "size"];
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var tag = _ref.tag,
      pill = _ref.pill,
      appearance = _ref.appearance,
      children = _ref.children,
      color = _ref.color,
      fluid = _ref.fluid,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(S.Button, Object.assign({
    ref: ref,
    as: tag,
    color: color,
    appearance: appearance,
    pill: pill ? 1 : 0,
    fluid: fluid ? 1 : 0,
    size: size
  }, rest), leftIcon && /*#__PURE__*/_react.default.createElement(S.FieldIcon, {
    className: "left-icon"
  }, leftIcon), children, rightIcon && /*#__PURE__*/_react.default.createElement(S.FieldIcon, {
    className: "right-icon"
  }, rightIcon));
});
Button.propTypes = {
  appearance: (0, _propTypes.oneOf)(['ghost', 'outline', 'solid', 'link']),
  tag: _propTypes.any,
  children: _propTypes.node,
  color: _propTypes.string,
  fluid: _propTypes.bool,
  leftIcon: _propTypes.node,
  pill: _propTypes.bool,
  rightIcon: _propTypes.node,
  size: _propTypes.string,
  theme: _propTypes.object
};
Button.defaultProps = {
  appearance: 'solid',
  tag: 'button',
  color: 'primary'
};
var _default = Button;
exports.default = _default;